import type { FC } from "react";

import Typography from "@/design-system/Typography";
import { CashbackComplaintStatus } from "@/src/cashback/CashbackCommonInterfaces";
import * as stylex from "@stylexjs/stylex";

import { ComposableSpacing, type PropsWithStyleX } from "../../../styles/tokens.stylex";

export type IStatusLabel = PropsWithStyleX & {
    status: CashbackComplaintStatus;
    statusLabel: string;
};

const StatusLabel: FC<IStatusLabel> = (props) => {
    const getAvailabilityState = (status?: CashbackComplaintStatus) => {
        switch (status) {
            case CashbackComplaintStatus.Pending:
                return styles.pending;
            case CashbackComplaintStatus.Rejected:
                return styles.rejected;
            case CashbackComplaintStatus.Approved:
                return styles.approved;
            default:
                return styles.withdrawn;
        }
    };

    return (
        <Typography
            textElement="p"
            fontStyle="BodyS"
            styleX={[styles.statusLabel, getAvailabilityState(props.status)]}
        >
            {props.statusLabel}
        </Typography>
    );
};

const styles = stylex.create({
    statusLabel: {
        display: "inline-block",

        "::before": {
            content: "⬤",
            marginRight: ComposableSpacing.s1,
        },
    },

    approved: {
        color: "#00CB53",
    },

    rejected: {
        color: "red",
    },

    pending: {
        color: "#FFB300",
    },

    withdrawn: {
        "::before": {
            display: "none",
        },
    },
});

export default StatusLabel;
